import type { Theme } from '@/types/ThemeOptions'

export const darkGray = '#222222'
export const mediumGray = '#555555'
export const lightGray = '#DDE0E5'
export const veryLightGray = '#f7f7f7'

export const white1 = 'rgba(255, 255, 255, 0.18)'
export const white2 = 'rgba(255, 255, 255, 0.13)'
export const white3 = 'rgba(255, 255, 255, 0.09)'

const primaryColor = 'var(--primary-color)'
const pageBackgroundColor = 'var(--page-background-color)'
const primaryColorDarker = 'var(--primary-color-darker)'

export const fallback: Partial<Theme> = {
  primaryColor: darkGray,
  secondaryColor: darkGray,
  messageColor: darkGray,
  labelColor: [darkGray, 'white'],
  headerBackground: ['white', 'transparent'],
  memberLinksColor: [darkGray, 'white'],
  memberLinksColorHover: [primaryColorDarker, 'rgba(255,255,255,0.5)'],
  logoHeight: '32px',
  footerBackgroundColor: ['white', white3],
  footerTextColor: [mediumGray, 'white'],
  bodyColor: [mediumGray, 'white'],
  headingColor: ['black', 'white'],
  pageBackgroundColor: ['white', 'black'],
  headerTopBorder: 'none',
  headerBottomBorder: 'none',
  headerDropShadow: 'none',
  headerHeight: '105px',
  secondaryButtonStyle: 'outline',
  infoColor: '#3b73d8',
  infoBackgroundColor: '#e6f0fb',
  successColor: '#006400',
  successBackgroundColor: '#f5fffa',
  warningColor: '#ffa500',
  warningBackgroundColor: '#fff6e6',
  errorColor: '#eb1c26',
  errorBackgroundColor: '#fee',
  promoColor: '#9877b0',
  promoBackgroundColor: 'rgba(152, 119, 176, 0.15)',
  selectArrowColor: ['var(--primary-color)', 'white'],
  cart: {
    headerBackgroundColor: [darkGray, white2],
    headerTextColor: 'white',
    headerBorder: 'none',
    backgroundColor: ['white', pageBackgroundColor],
    priceBackgroundColor: ['#f7f7f7', white2],
    dividerColor: [lightGray, white2],
    removeButtonBackgroundColor: [lightGray, white2],
  },
  dialog: {
    backgroundColor: ['#F7F9FA', pageBackgroundColor],
    headerTextColor: ['black', 'white'],
    headerBackground: ['white', white3],
    headerIconColor: ['#555555', white1],
    headerBorder: ['1px solid #DDE0E6', 'none'],
  },
  mobileFooter: {
    backgroundColor: ['#ffffff', pageBackgroundColor],
    textColor: ['#545557', '#A1A8AF'],
    cartButtonBackgroundColor: ['#ffffff', pageBackgroundColor],
    cartButtonHoverBackgroundColor: ['#ffffff', pageBackgroundColor],
    cartButtonBorder: ['2px solid #BFC1CA', '2px solid rgba(255, 255, 255, 0.2)'],
    cartButtonIconColor: ['#747981', '#ffffff'],
    cartBadgeBackgroundColor: '#ff0000',
    cartBadgeTextColor: '#ffffff',
    priceTextColor: ['#545557', '#E0E3E5'],
  },
  backButton: {
    iconColor: ['#282B37', '#ffffff'],
    backgroundColor: ['white', primaryColor],
    shadow: '0px 0px 5px rgba(0, 0, 0, 0.4)',
  },
  calendar: {
    backgroundColor: ['rgba(255, 255, 255, 0.1)', 'rgba(34, 36, 51, 0.1)'],
    buttonColor: ['#ffffff', '#A1A8AF'],
    buttonIconColor: '#282B37',
    dayTextColor: ['#282B37', '#E0E3E5'],
    todayBackgroundColor: ['#EFF0F5', 'rgba(255,255,255,0.2)'],
    disabledDayTextColor: ['#BFC1CA', '#6B717A'],
    divider: ['1px dashed #cccccc', '1px dashed rgba(255, 255, 255, 0.2)'],
    monthTextColor: ['#282B37', '#E0E3E5'],
    weekdayTextColor: ['#525A6C', '#A1A8AF'],
    legendTextColor: ['#525A6C', '#A1A8AF'],
  },
  steppers3: {
    iconColor: [mediumGray, 'white'],
    border: [`2px solid ${lightGray}`, `2px solid ${white1}`],
    buttonBackgroundColor: ['white', 'transparent'],
    buttonBackgroundHoverColor: ['white', 'transparent'],
    borderHoverColor: ['#bfc1ca', 'rgba(255, 255, 255, 0.5)'],
    count: {
      backgroundColor: [lightGray, 'transparent'],
      border: [`2px solid ${lightGray}`, `2px solid ${white1}`],
    },
  },
  radioButton: {
    borderColor: ['var(--medium-gray)', primaryColor],
    backgroundColor: ['white', 'transparent'],
    checked: {
      backgroundColor: ['white', 'transparent'],
      borderColor: primaryColor,
    },
  },
  editOrder: {
    sessionBorderColor: ['#dde0e5', white3],
    ticketBackgroundColor: ['#eff0f5', white3],
  },
  divider: [`${lightGray} 1px solid`, `${white3} 1px solid`],
}
